import React, { useState } from 'react';
import styles from './UnrankedTournamentsSection.module.css';

/**
 * Rozwijana sekcja „Nierankingowe" na dole listy turniejów — wspólna dla zakładek
 * Trwające i Zakończone.
 *
 * Komponent jest czysto prezentacyjny: listę dostaje przez props, sam nic nie pobiera.
 * Dzięki temu Trwające podają turnieje ACTIVE, a Zakończone turnieje COMPLETED
 * z wybranego rocznika, bez żadnej logiki statusów tutaj.
 *
 * Pusta lista → null, czyli sekcji nie ma wcale. Klub bez turniejów towarzyskich (albo
 * rocznik bez nich) nie widzi pustego nagłówka.
 *
 * `inactive` wyszarza kafelki — jasny kolor jest zarezerwowany dla turniejów trwających,
 * więc w archiwum sekcja musi wyglądać jak reszta zakończonych.
 */
const UnrankedTournamentsSection = ({ tournaments, onSelect, inactive = false }) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!tournaments || tournaments.length === 0) return null;

    return (
        <div className={styles.section}>
            <button
                type="button"
                className={styles.toggle}
                data-testid="unranked-toggle"
                aria-expanded={isOpen}
                onClick={() => setIsOpen((open) => !open)}
            >
                {`${isOpen ? '▾' : '▸'} Nierankingowe (${tournaments.length})`}
            </button>

            {isOpen && (
                <div className={styles.list}>
                    {tournaments.map((tournament) => (
                        <button
                            key={tournament.id}
                            type="button"
                            className={`${styles.tournamentButton} ${inactive ? styles.inactive : ''}`.trim()}
                            onClick={() => onSelect(tournament)}
                        >
                            {tournament.title}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default UnrankedTournamentsSection;
